export default [
  {
    path: '/pricing-overrides',
    name: 'pricing-overrides',
    component: () => import('@/views/billing/pricing-override/pages/PricingOverrideList.vue'),
    meta: {
      resource: 'pricing-override',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Pricing Overrides',
      breadcrumb: [
        {
          text: 'Pricing Overrides',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pricing-overrides/new',
    name: 'new-pricing-overrides',
    component: () => import('@/views/billing/pricing-override/pages/CreatePricingOverride.vue'),
    meta: {
      resource: 'pricing-override',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Create Pricing Override',
      breadcrumb: [
        {
          text: 'Pricing Overrides',
          to: '/pricing-overrides',
        },
      ],
    },
  },
  {
    path: '/pricing-overrides/edit/:id',
    name: 'edit-pricing-overrides',
    component: () => import('@/views/billing/pricing-override/pages/EditPricingOverride.vue'),
    meta: {
      resource: 'pricing-override',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Pricing Override',
      breadcrumb: [
        {
          text: 'Pricing Overrides',
          to: '/pricing-overrides',
        },
      ],
    },
  },
]
